import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import { gstinCall } from "../serviceCall"
import compileErrors from "../compileErorrs"
import { setLoading } from "../../feature/authSlice"

export const getGstinDetailsApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    gstinCall({
      url: apiConstants.VENDOR.GET_GSTIN_DETAIL,
      method: 'get',
      data: data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
